import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ArrowDownIcon, ArrowRightSIcon, ArrowUpIcon, CommunityMembersIcon, MembersIcon, iconFontSize } from '../../components/IconComponent';
import BoxContent from '../../components/BoxContent';
import LinkComponent from '../../components/Link';
import { useNavigate } from 'react-router-dom';
import { config_path } from '../../router/config.path';
import CardComponent from '../../components/Card';
import { GetIconColor } from '../../theme/main_style';
import { replaceParamTranslation } from '../../utils/util';
export default function MyCommunitiesView2(props) {
    const { groups } = props;
    const [showContent, setShowContent] = useState(false);
    const { t } = useTranslation();
    const { palette } = useTheme();
    const navigate = useNavigate();

    return (
        <BoxContent noPaddingX>
            <Stack direction={'row'} sx={{ cursor: 'pointer' }} mt={1} onClick={() => setShowContent(!showContent)}>
                <Stack flex={1}>
                    <Typography variant='caption'>{t('my_communities_title')}</Typography>
                </Stack>
                <Stack flex={0.2} direction='row' justifyContent={'flex-end'}>
                    {showContent ? <ArrowUpIcon size={iconFontSize.sm} color={palette.primary.main}/> : <ArrowDownIcon size={iconFontSize.sm} color={palette.primary.main}/>}
                </Stack>
            </Stack>
            {showContent && <Box>
                <>
                    {(!groups || groups.length === 0) ? 
                        <Box sx={{ marginTop: 2 }}>
                            <Typography>{t('no_communities_yet')}</Typography>
                        </Box>
                        : 
                        <>
                        {groups.map((item, index) => (
                            <Box
                                key={`${index}`}
                                mb={1}
                                borderBottom={`1px solid ${palette.border.main}`}
                                onClick={() => {navigate(config_path.communities, { state: { community: item } })}}
                                sx={{ cursor: 'pointer' }} 
                            >
                                <CardComponent paddingY={1} noBorder paddingTop={0}>
                                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                                        <Stack direction="row" alignItems="center">
                                            <CommunityMembersIcon sx={{ marginRight: 5 }}color={GetIconColor().default}/>
                                            <Stack marginLeft={2} spacing={0} marginBottom={1}>
                                                <Typography variant='subtitle1'>{item.group}</Typography>
                                                {item.isOwner ? 
                                                <Chip size='small' sx={{ background: palette.primary.light, padding: 0, height:'18px' }} label={replaceParamTranslation(t('ownedBy'), [t('you')])} /> :
                                                <Chip size='small' sx={{ background: palette.secondary.light, padding: 0, height:'18px' }} label={replaceParamTranslation(t('ownedBy'), [item.ownerName])} />
                                            }
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </CardComponent>
                            </Box>
                        ))}
                        </>
                    }
                    <Box my={2}>
                        <center><LinkComponent onClick={() => navigate(config_path.communities, { state: { from : 'my_plans' } })}>{t('manage')}</LinkComponent></center>
                    </Box>
                </>
            </Box>}
        </BoxContent>
    )
}

